import {
  ChangeDetectionStrategy,
  Component,
  computed,
  ElementRef,
  input,
  output,
  viewChild,
} from "@angular/core";

export type ButtonVariant = "primary" | "secondary";
export type ButtonSize = "small" | "medium" | "large";

@Component({
  selector: "app-cmn-button",
  template: `
    <button
      #buttonElement
      [class]="classes()"
      [type]="type()"
      [disabled]="disabled()"
      [title]="title()"
      [attr.aria-label]="ariaLabel() || null"
      [attr.aria-busy]="ariaBusy() ? 'true' : null"
      (click)="handleClick($event)"
    >
      <ng-content></ng-content>
    </button>
  `,
  styleUrls: ["./cmn-button.component.scss"],
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class CmnButtonComponent {
  private buttonElement =
    viewChild<ElementRef<HTMLButtonElement>>("buttonElement");

  variant = input<ButtonVariant>("secondary");
  size = input<ButtonSize>("medium");
  type = input<"button" | "submit" | "reset">("button");
  buttonClass = input("");
  disabled = input(false);
  title = input("");
  ariaLabel = input("");
  ariaBusy = input(false);

  buttonClick = output<MouseEvent>();

  protected readonly classes = computed(() =>
    ["cmnh-button", this.variant(), this.size(), this.buttonClass()]
      .filter((value) => !!value)
      .join(" ")
  );

  handleClick(event: MouseEvent): void {
    this.buttonClick.emit(event);
  }

  scrollIntoView(options?: ScrollIntoViewOptions): void {
    this.buttonElement()?.nativeElement.scrollIntoView(options);
  }
}
